module.exports = __webpack_public_path__ + "static/img/no-data.518969e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/no-data.png
// module id = cL4u
// module chunks = 1